import styled from 'styled-components'
import { useActiveChainId } from 'hooks/useActiveChainId'
import { NATIVE } from '@donaswap/sdk'
import Link from 'next/link'
import { NetworkAlertChains } from '../NetworkAlert/ShouldShowAlert'
import { FaucetIcon, BoxProps } from '@donaswap/uikit'

const RootWrapper = styled.div<{ chainId: NetworkAlertChains }>`
  color: ${({ theme }) => theme.colors.textSubtle};
`

export function FaucetAlert({ color }: Pick<BoxProps, 'color'>) {
  const { chainId } = useActiveChainId()

  const { faucet } = NATIVE[chainId]

  return faucet ? (
    <RootWrapper chainId={chainId} >
      <Link href={faucet} target="_blank">
        <FaucetIcon width={24} height={24} color={color} marginTop={1} />
      </Link>
    </RootWrapper>
  ) : null
}
